import { render } from "./PaginationVideosAdmin.vue?vue&type=template&id=70ba12ab&scoped=true"
import script from "./PaginationVideosAdmin.vue?vue&type=script&lang=ts"
export * from "./PaginationVideosAdmin.vue?vue&type=script&lang=ts"

import "./PaginationVideosAdmin.vue?vue&type=style&index=0&id=70ba12ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70ba12ab"

export default script